import { render, staticRenderFns } from "./DiscountMemberListTable.vue?vue&type=template&id=f468a23c&"
import script from "./DiscountMemberListTable.vue?vue&type=script&lang=js&"
export * from "./DiscountMemberListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports